import { Link } from "react-router-dom";
import { Phone, MapPin, BadgeCheck, FileCheck2 } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-metallic/60 bg-surface/30">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14 md:py-16 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={SITE.logo} alt="Borås Fritid logotyp" className="h-14 w-14 object-contain" />
            <div>
              <p className="font-display font-extrabold text-lg text-white tracking-tight">
                BORÅS <span className="text-gradient-blue">FRITID</span>
              </p>
              <p className="text-[10px] tracking-[0.28em] text-slate-400 font-mono-brand">KÖPER · SÄLJER · BYTER</p>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            Personlig handel med husvagnar och husbilar i Borås. Vi hjälper dig med köp, försäljning och byte —
            från första kontakt till nyckelöverlämning.
          </p>
        </div>

        <div data-testid="footer-contact">
          <p className="font-mono-brand text-xs tracking-[0.3em] text-electric mb-5">KONTAKT</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>
              <a
                href={`tel:${SITE.phone}`}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 hover:text-white transition-colors"
              >
                <Phone size={16} className="text-brand" />
                {SITE.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-brand mt-0.5 shrink-0" />
              <span>
                {SITE.address}
                <br />
                {SITE.zip}
              </span>
            </li>
            <li className="flex items-center gap-3">
              <FileCheck2 size={16} className="text-emerald-400" />
              {SITE.fskatt}
            </li>
            <li className="font-mono-brand text-xs text-slate-400">Org.nr {SITE.orgnr}</li>
          </ul>
        </div>

        <div>
          <p className="font-mono-brand text-xs tracking-[0.3em] text-electric mb-5">SNABBLÄNKAR</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link to="/fordon" data-testid="footer-link-fordon" className="hover:text-white transition-colors">Våra fordon</Link></li>
            <li><Link to="/salj" data-testid="footer-link-salj" className="hover:text-white transition-colors">Sälj till oss</Link></li>
            <li><Link to="/om-oss" data-testid="footer-link-om-oss" className="hover:text-white transition-colors">Om oss</Link></li>
            <li><Link to="/hitta-hit" data-testid="footer-link-hitta-hit" className="hover:text-white transition-colors">Vägbeskrivning</Link></li>
            <li><Link to="/kontakt" data-testid="footer-link-kontakt" className="hover:text-white transition-colors">Kontakt</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-metallic/60">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <p data-testid="footer-copyright">© {year} {SITE.name} · Ägare: {SITE.owner}</p>
          <p className="flex items-center gap-2">
            <BadgeCheck size={14} className="text-emerald-400" />
            {SITE.fskatt}
          </p>
        </div>
      </div>
    </footer>
  );
}
